import { ArrowUpRight, Lock } from "lucide-react";

/**
 * Locked/unlocked "Advanced" strip. Same real content in both cases —
 * blurred for free/thrifter, clear for reseller/pro. No fake data ever.
 *
 * Props:
 *   locked          - boolean, true => blur + upgrade CTA
 *   ctaTier         - "reseller" | "pro", target tier for the upgrade
 *   onUpgrade       - () => void, opens the upgrade modal on the chosen tier
 *   ctaLabel        - "Unlock ..." string
 *   heading         - small uppercase eyebrow
 *   children        - the real content (numbers/rows)
 *   testid          - data-testid
 */
export default function AdvancedStrip({ locked, ctaTier = "reseller", onUpgrade, ctaLabel, heading, children, testid }) {
  return (
    <div
      className="mt-3 relative rounded-xl border border-white/[0.06] bg-black/25 p-3 sm:p-4 overflow-hidden"
      data-testid={testid}
    >
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-mono-num text-white/60">
          {locked && <Lock size={10} />} {heading}
        </div>
        {locked && (
          <span className="text-[9px] uppercase tracking-widest text-white/40">
            {ctaTier === "pro" ? "Pro" : "Reseller & Pro"}
          </span>
        )}
      </div>

      <div className={locked ? "select-none pointer-events-none" : ""} style={locked ? { filter: "blur(5px)", opacity: 0.85 } : undefined} aria-hidden={locked ? "true" : undefined}>
        {children}
      </div>

      {locked && (
        <div className="absolute inset-x-0 bottom-0 p-3 sm:p-4 flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-2 sm:gap-3"
             style={{ background: "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.75) 55%, rgba(0,0,0,0.92) 100%)" }}>
          <div className="text-[11px] sm:text-xs text-white/85 leading-snug">
            {ctaLabel}
          </div>
          <button
            data-testid={`${testid}-upgrade`}
            onClick={() => onUpgrade?.(ctaTier)}
            className="inline-flex items-center justify-center gap-1 px-3 py-2 sm:py-1.5 rounded-full bg-white text-[#0F172A] text-[11px] font-semibold hover:bg-zinc-100 transition-colors flex-shrink-0 w-full sm:w-auto min-h-[44px] sm:min-h-[36px]"
          >
            Unlock <ArrowUpRight size={11} />
          </button>
        </div>
      )}
    </div>
  );
}
